import { useState, Dispatch, SetStateAction } from "react";
import { useTemplate } from "@utils/useTemplate";
import { Template, UseDeleteTemplateReturn } from "@shared/interfaces/Template";
import { toastService } from "@services/ToastService";

const useDeleteTemplate = (): UseDeleteTemplateReturn => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState<number | null>(
    null
  );

  const { deleteTemplate } = useTemplate();

  const handleDelete = async () => {
    if (selectedTemplateId !== null) {
      try {
        await deleteTemplate(selectedTemplateId);
      } catch (error) {
        toastService.error("Failed to delete template");
        console.error("Error deleting template:", error);
      } finally {
        setIsDeleteModalOpen(false);
      }
    }
  };

  return {
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    selectedTemplateId,
    setSelectedTemplateId,
    handleDelete,
  };
};

export default useDeleteTemplate;
